export function isUserInternal(userScope) {
    return userScope.organization.name.toLocaleLowerCase().includes('carrefour');
}
//# sourceMappingURL=userScope.utils.js.map